import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { DropdownButton } from "react-bootstrap";
import { ButtonGroup } from "react-bootstrap";
import Dropdown from "@restart/ui/esm/Dropdown";
import { circuitUsageActions } from "../../../../store/external/circuit-usage-reducer/circuit-usage.reducer";
import { createRequestActions } from "../../../../store/external/request-reducer/create-request.reducer";
import { ConfirmationModal } from "../../../common/modal/modal.component";
import {
    RAISE_REQUEST_LINKS as RaiseRequestLink
    , CIRCUIT_CATEGORIES as CircuitCategories
    , REQUEST_TYPES_ID
    , REQUEST_TYPE
} from "../../../../constants/external-constants";
import { DASHBOARD_MENU as DashboardMenu, CIRCUIT_STATUS_PERSONAL as CircuitStatus } from "../../../../utils/constant.utils";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import { MATRIX_INDICATOR, ACCESS_MODULE } from "../../../../utils/rbac-constants.utils";
import Icon from "../../../icon";
import Translation from "../../../common/translation/translation.component";
import "./subscription-header.component.css";
import { CIRCUIT_STATUS } from "../../../../constants/external-constants";
import { convertToDate } from '../../../../utils/helpers.utils';
import FormatDate from "../../../common/date/format-date.component";

class SubscriptionOverviewInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showComponent: true
        }
        this.ConfirmationModal = React.createRef();
    }

    componentWillMount() {
        const { fetchCreateRequestItems } = this.props;

        fetchCreateRequestItems();
    }

    updateNavSelection = () => {
        var mainNavs = document.querySelectorAll(".main-menu");
        var subNav = document.querySelectorAll(".sub-list");
        subNav[0].classList.remove("subSelected");
        mainNavs[0].classList.remove("isActive");
        mainNavs[1].classList.add("isActive");

    }

    openRequestModal = (id, type) => {
        const { activeMenu, history, setRequestType, setTakeActionCircuitCode } = this.props;
        setRequestType(id, type);
        setTakeActionCircuitCode();

        if (activeMenu == DashboardMenu.Personal) {
            history.push("Dashboard/" + RaiseRequestLink.orderRequest.link + id);
        } else {
            history.push("Report/"+RaiseRequestLink.orderRequest.link + id);
        }

    };

    resetUrl = () => {
        this.props.history.goBack();
    }

    handleGeneratePDF = e => {
        e.preventDefault();
        this.ConfirmationModal.current.handleClose();
    }

    render() {
        const { userLogo, userName, phoneNumberType, userPhoneNumber, setAsPrimary, activeCircuit,
            planInfo, planName, vendorName, circuitStatus, simCount, simType, equipmentCount, equipmentModel, subscriptionIsPrimary, currencySymbol, circuitData, activeMenu, upgradeEligibilityDate } = this.props;

        const { requestTypes, isRequestTypesLoaded } = this.props.createRequest;
        let noAccess = activeMenu == DashboardMenu.Personal ?
            validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.PersonalDashboardRW])
            : validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MyDirectReportsDashboardRW]);

        let actionRequestItems;
        if (circuitData && isRequestTypesLoaded) {

            var actionRequestData = circuitData.subscriptionInfo.CircuitCategoryModel.CircuitCategoryId == CircuitCategories.mobile ?
                (requestTypes.Wireless ? requestTypes.Wireless.ActionsAndRequests : []) : (requestTypes.Wireline ? requestTypes.Wireline.ActionsAndRequests : []);

            if (requestTypes.Wireless && Object.keys(requestTypes.Wireless).length) {
                var actionsAndRequests = null;

                if (actionRequestData.length) {
                    actionsAndRequests = [
                        actionRequestData.map((requestType) => {
                            if (requestType.RequestTypeID === REQUEST_TYPES_ID.intlRoamingAccess) {
                                requestType.RequestType = REQUEST_TYPE.InternationalAccess;
                            }
                            return (
                                <Dropdown.Item key={requestType.RequestTypeID}
                                    onClick={() => this.openRequestModal(requestType.RequestTypeID, requestType.RequestType)}>
                                    {requestType.RequestType}
                                </Dropdown.Item>
                            );
                        }),
                    ];
                }

                actionRequestItems = actionsAndRequests;

            }

        } else {
            actionRequestItems = null;
        }

        return (
            <div>
                <ConfirmationModal
                    ref={this.ConfirmationModal}
                    title={<Translation translationKey="export_to_pdf" />}
                    messageBody={<Translation translationKey="do_you_like_this_to_export_to_pdf_file" />}
                    confirmAction={this.handleGeneratePDF}
                    closeLabel={<Translation translationKey="modal_close_cancel_button" />}
                    confirmLabel={<Translation translationKey="yes_button" />}
                />
                <div className="subscription-detail-container">
                    <div className="subscription-detail-info">
                        <div className="subscription-type-container">
                            <h1 className="subscription-type">{vendorName}</h1>
                            <h1 className="subscription-type">{simCount <= 1 ? "": "(" + simCount + ")" } <Translation translationKey="sim_type" />: {simType}</h1>
                            <h1 className="subscription-type">{phoneNumberType}</h1>
                        </div>
                    </div>
                  

                    <div className="subscription-plan-container">
                        <img
                            className="subscription-user-image"
                            src={userLogo}
                            alt="avatar"
                        />
                        <div className="subscription-user-container">
                            <div className="subscription-user-detail">
                           
                                <h1 className="subscription-user-detail">{userName}</h1>

                                <div className="three-dot-container" hidden={circuitStatus == CircuitStatus.InService || circuitStatus == CircuitStatus.Pending ? false : true } >
                                    <DropdownButton
                                        hidden={noAccess}
                                        as={ButtonGroup}
                                        title=""
                                        id="bg-vertical-dropdown-2"
                                        className="subscription-price-btn"
                                    >
                                        {actionRequestItems}
                                    </DropdownButton>
                                </div>
                            </div>
                            <div className="subscription-user-sub-detail">

                                <h2 className="subscription-user-phone">{userPhoneNumber}</h2>
                                {subscriptionIsPrimary ?
                                    <Icon
                                        customClassName="icon-check"
                                        name="check-circle-solid"
                                        labelValue={<Translation translationKey="primary_number" />}
                                        size="15px"
                                        hidden={subscriptionIsPrimary }
                                        containerClass="icon-container" /> :
                                    <a hidden={true} className="set-as-primary-number" onClick={() => setAsPrimary(activeCircuit)}>
                                        <Translation translationKey="set_as_primary_number" />
                                    </a>
                                }
                            </div>
                            <div className="subscription-user-sub-detail">
                                <h2 className={`subscription-user-phone ${activeCircuit.CircuitStatus === CIRCUIT_STATUS.inService.name ? "status-inservice" : "status-suspended"}`}>
                                    {activeCircuit.CircuitStatus}
                                </h2>
                            </div>
                            <div className="subscription-user-sub-detail">
                                {equipmentCount > 0 ?
                                    <h2 className="subscription-user-phone">{equipmentModel}</h2>
                                    :
                                    <h2 className="subscription-user-phone">N/A</h2>
                                }
                            </div>
                            <div className="subscription-user-sub-detail">
                                <h2 className="subscription-user-phone"><Translation translationKey="upgrade_eligibility_date" />: {upgradeEligibilityDate !== "" ? <FormatDate date={convertToDate(upgradeEligibilityDate)} /> : "N/A" }</h2>
                            </div>
                        </div>
                        <div className="subscription-plan-item-container" id="report">
                            <div className="subscription-list-plan">
                                <div className="subscription-title-container">
                                    <h1 className="subscription-plan-title">{planInfo.length > 0 ? planInfo[0].PlanName : <Translation translationKey="no_plan_available" />}</h1>
                                    <div className="details-info">
                                        <Icon
                                            customClassName="icon-info-circle icon-info-header"
                                            name="info-circle-solid"
                                            size="15px"
                                        />
                                        <div className="plan-details-list">
                                            <ul className="plan-details-list-item">
                                                {planInfo.length > 0 ? planInfo.map((item, id) => <li key={id}>{item.ComponentDetails}</li>) : <Translation translationKey="no_plan_available" />}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="subscription-detail-list">
                                    <table className="table subscription-header-table">
                                        <tbody>
                                            {planInfo.length > 0 ? planInfo.map((item, id) =>
                                                <tr key={id}>
                                                    <td>{item.ComponentName}</td>
                                                    <td>{currencySymbol}{` ${item.ComponentCost}`}</td>
                                                </tr>
                                            ) : ""}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="subscription-total-container">
                                <h1 className="subscription-total-amount">{currencySymbol}{` ${(planInfo != null ? planInfo.reduce((a, v) => a = a + v.ComponentCost, 0) : 0)}`}</h1>
                                <h2 className="subscription-total-label">Total</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    state => {
        const { circuitUsage, createRequest } = state;
        return {
            ...circuitUsage
            , createRequest
        };
    },
    dispatch =>
        bindActionCreators(
            Object.assign({}, circuitUsageActions, createRequestActions),
            dispatch
        )
)(SubscriptionOverviewInfo);